export default __webpack_public_path__ + "static/media/52.84b72828.png";